import { DatePicker as OriginalDatePicker } from 'antd-mobile';
import React, { forwardRef } from 'react';
export const ModelessDatePicker = forwardRef((props, ref) => {
    const { render } = props;
    if (props.__designMode === 'design') {
        return React.createElement("div", { ref: ref }, render?.(new Date()));
    }
    return (React.createElement(OriginalDatePicker, Object.assign({}, props, { ref: ref }), (value) => {
        return typeof render === 'function' ? render?.(value) : render;
    }));
});
export default OriginalDatePicker;
